import { ReactComponent as LinkedInIcon } from '@/assets/images/svg/logos/social/linkedin-square.svg';
import { ReactComponent as TwitterIcon } from '@/assets/images/svg/logos/social/twitter-cropped.svg';
import SocialProofCard, { SocialProofCardProps } from '@/components/_atoms/social-proof-cards/SocialProofCard';
import { COLORS } from '@/styles/color';
import { mediaBreakpointUp, square } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface SocialProofSocialMediaCardProps extends SocialProofCardProps {
  name: string;
  handle: string;
  avatar?: ReactNode;
  logo: 'twitter' | 'linkedin';
}

const SocialProofSocialMediaCard: FC<SocialProofSocialMediaCardProps> = (props) => {
  return (
    <SocialProofCard cta={props.cta}>
      <Header>
        <DetailsWrapper>
          {props.avatar ? <SocialAvatarWrapper>{props.avatar}</SocialAvatarWrapper> : null}

          <TextWrapper>
            <SocialName>{props.name}</SocialName>
            <SocialHandle>{props.handle}</SocialHandle>
          </TextWrapper>
        </DetailsWrapper>

        <LogoWrapper>{renderSocialMediaLogo(props.logo)}</LogoWrapper>
      </Header>

      <ContentWrapper>{props.children}</ContentWrapper>
    </SocialProofCard>
  );
};

export default SocialProofSocialMediaCard;

const renderSocialMediaLogo = (logo: SocialProofSocialMediaCardProps['logo']) => {
  switch (logo) {
    case 'twitter':
      return <TwitterIcon />;
    case 'linkedin':
      return <LinkedInIcon />;
    default:
      return null;
  }
};

// Styled Components

const ContentWrapper = styled.p`
  margin-bottom: auto;
  ${customTextSize(18, 26)};

  a {
    color: ${COLORS.BLUE.LOWLIGHT};
  }

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(24, 34)};
  }
`;

const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaBreakpointUp('tablet')} {
    flex-direction: row;
  }
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${remCalc(30)};
`;

const SocialAvatarWrapper = styled.div`
  position: relative;
  ${square(40)};
  margin-bottom: ${remCalc(10)};
  border-radius: 100%;
  overflow: hidden;

  ${mediaBreakpointUp('tablet')} {
    ${square(50)};
    margin-right: ${remCalc(16)};
  }
`;

const SocialName = styled.span`
  ${customTextSize(16, 26)};
  font-weight: ${FONT_WEIGHTS.BOLD};
`;

const SocialHandle = styled.span`
  ${customTextSize(14, 20)};
`;

const LogoWrapper = styled.div`
  width: ${remCalc(30)};
  align-self: flex-start;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
